import { AfterViewInit, Component, OnInit, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SecurityService } from '../../services/security.service';
import { environment } from '@env/environment';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {

  internalCode: string | null = null;
  consultor = signal<any | null>(null);
  nextRoute = '/app/services';


  constructor(
    private title: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private securityService: SecurityService,
    private _loaderService: LoaderService 

  ) {
    this.title.setTitle('Onboarding Digital | Inicio');
    this.internalCode = this.activatedRoute.snapshot.paramMap.get('internalCode');
  }

  ngOnInit(): void {
    if (this.internalCode != null) {
      this.loadConsultorByInternalCode(this.internalCode);
    } else if (localStorage.getItem('consultor')) {
      this.loadConsultorFromSession();
    }
  }

  ngAfterViewInit(): void {
    this._loaderService.hide();
  }

  private loadConsultorByInternalCode(code: string): void {
    this._loaderService.show();
    localStorage.setItem('consultor', code);
    this.securityService.setConsultor(code).subscribe({
      next: (response: any) => {
        this.setConsultorData(response);
        this.storeConsultorInLocalStorage(response);
        this._loaderService.hide();

      },
      error: (error) => {
        console.error('Error loading consultor by internal code:', error);
        this._loaderService.hide();
      }
    });
  }

  private loadConsultorFromSession(): void {
    this._loaderService.show();
    this.securityService.getConsultor().subscribe({
      next: (response: any) => {
        this.setConsultorData(response);
        this._loaderService.hide();

      },
      error: (error) => {
        console.error('No consultor found in session:', error);
        this._loaderService.hide();

      }
    });
  }

  private setConsultorData(data: any): void {
    this.consultor.set({
      ...data,
      qrImage: `${environment.serverUrl}/assets/qr/${data.qrCode}`
    });
  }

  storeConsultorInLocalStorage(data: any): void {
    localStorage.setItem('consultor', this.internalCode ?? '');
    localStorage.setItem('qr', `${environment.serverUrl}/assets/qr/${data.qrCode}`);
    localStorage.setItem('consultorName', data.name);
    localStorage.setItem('user', data.user);
    localStorage.setItem('phone', data.phone);
    localStorage.setItem('session', data.token ?? '');
  }

  async next() {
    this._loaderService.show();
    this.router.navigateByUrl(this.nextRoute);
  }

}
